import { markRaw, defineAsyncComponent, type Raw, type DefineComponent } from 'vue';

export const defineRawAsyncComponent = (args): Raw<DefineComponent> => markRaw(defineAsyncComponent(args));
